/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandDribbble = createReactComponent("brand-dribbble", "IconBrandDribbble", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 3.6c5 6 7 10.5 7.5 16.2", key: "svg-1" }],
  ["path", { d: "M6.4 19c3.5 -3.5 6 -6.5 14.5 -6.4", key: "svg-2" }],
  ["path", { d: "M3.1 10.75c5 0 9.814 -.38 15.314 -5", key: "svg-3" }]
]);

export { IconBrandDribbble as default };
//# sourceMappingURL=IconBrandDribbble.js.map
